var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.744 8.175L16.68 12.111C16.824 12.255 17 12.327 17.208 12.327C17.416 12.327 17.592 12.255 17.736 12.111C17.88 11.967 17.952 11.791 17.952 11.583C17.952 11.375 17.88 11.199 17.736 11.055L12 5.319L6.264 11.055C6.12 11.199 6.048 11.375 6.048 11.583C6.048 11.791 6.12 11.967 6.264 12.111C6.408 12.255 6.584 12.327 6.792 12.327C7 12.327 7.176 12.255 7.32 12.111L11.256 8.175V16.863H1.512V1.863H22.512V16.863H12.744V8.175ZM11.256 18.375V24.375H12.744V18.375H24V1.863C24 1.447 23.856 1.095 23.568 0.807C23.28 0.519 22.928 0.375 22.512 0.375H1.512C1.096 0.375 0.736 0.519 0.432 0.807C0.144 1.095 0 1.447 0 1.863V18.375H11.256Z",
    fill: "#415385"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.314992dced5edeb63c52f70badd6bb59.svg";
export { ForwardRef as ReactComponent };